module.exports = __webpack_public_path__ + "img/5ea7178.png";